import { GetValue } from '../GetValue/GetValue'
import { SurveyEngine_Models_Answer, SurveyEngine_Models_BaseResponse, SurveyEngine_Models_GetValueResponse, SurveyEngine_Models_RecordMessageResponse } from '../../../api'

interface RecordMessageProps {
  id: number,
  question: string,
  confirmQuestion: string,
  answers: SurveyEngine_Models_Answer[],
  defaultAnswer: string,
  maskInput: boolean,
  inputFormat?:string,
  inputBoxHeight: number,
  Validation: any,
  isError: boolean,
  focus: boolean,
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const RecordMessage = (props: RecordMessageProps) => {
  const transformResponse = (response: SurveyEngine_Models_GetValueResponse) => {
    if (response) {
      let res: SurveyEngine_Models_RecordMessageResponse = {
        commandIndex: response.commandIndex,
        //should not override if command type is "Remove"
        commandType: response.commandType?.toLocaleLowerCase() === 'remove' ? "Remove" : "RecordMessage",
        value: response.value
      }
      props.callback(res);
    }
  }
  
  return (
    <GetValue id={props.id}
      question={props.question}
      confirmQuestion={props.confirmQuestion}
      defaultAnswer={props.defaultAnswer}
      maskInput={props.maskInput}
      answers={props.answers}
      inputFormat={props.inputFormat}
      Validation={{
        ...props.Validation,
        alphaNumericOnly: props.Validation.dataType.toLocaleLowerCase()  === 'alphanumeric' ? true : false,
        postiveNumbersOnly: false,
        inputHeight: props.inputBoxHeight,
        CompareList: []
      }}
      isError={props.isError}
      focus={props.focus}
      callback={transformResponse} />
  )
}

